var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckEngine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#040006;}.cls-3{fill:#d5ea06;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-check-engine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_6",
    "data-name": 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.06,58.8v4.59H126.83V86.55h36.52a.41.41,0,0,1,.41.41V116.8h16.7V101.68h5.42v40.37h-5.42V127.24H164.18V140a.83.83,0,0,1-.24.58l-22.3,22a2.92,2.92,0,0,1-2,.84H99a2.92,2.92,0,0,1-2.16-1L84,148.22,82,146h-10A4.07,4.07,0,0,1,68,142V127.24H48.79v18.57H43.36V103.87h5.43v18.57H68V108.35a4.07,4.07,0,0,1,4.06-4.07h9.59l2-2.26L96.42,87.53a2.93,2.93,0,0,1,2.18-1h22.6V63.39H105.55V58.8h36.51m2.82-6.68H102.73A3.86,3.86,0,0,0,98.87,56V66.2a3.86,3.86,0,0,0,3.86,3.86h11.79v9.81H98.6a9.57,9.57,0,0,0-7.18,3.24L78.63,97.61H72.05a10.74,10.74,0,0,0-10.74,10.74v7.41H55.47v-15a3.55,3.55,0,0,0-3.55-3.55H40.23a3.54,3.54,0,0,0-3.54,3.55v48.2a3.54,3.54,0,0,0,3.54,3.55H51.92a3.55,3.55,0,0,0,3.55-3.55v-15h5.84v8a10.74,10.74,0,0,0,10.74,10.74h7l12.8,14.16A9.56,9.56,0,0,0,99,170h40.64a9.6,9.6,0,0,0,6.73-2.75l22.3-22a7.5,7.5,0,0,0,2.24-5.34v-6.05h2.92v11a3.81,3.81,0,0,0,3.81,3.81h11.16a3.82,3.82,0,0,0,3.81-3.81V98.81A3.81,3.81,0,0,0,188.75,95H177.59a3.8,3.8,0,0,0-3.81,3.81v11.32h-3.34V87a7.1,7.1,0,0,0-7.09-7.09H133.51V70.06h11.37a3.86,3.86,0,0,0,3.86-3.86V56a3.86,3.86,0,0,0-3.86-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckEngine);
export default __webpack_public_path__ + "static/media/ic-check-engine.71e81172b84149c2f750a420fe7736bc.svg";
export { ForwardRef as ReactComponent };